export * from './home.component';
export * from './user-management/UserManagmentRouteComponent';
export * from './profile/ProfileManagementRouteComponent'
export * from './user-management/users-list/users-list.component';
export * from './user-management/user-invite/user-invite.component';
export * from './user-management/user-details/users-details.component';
export * from './resources/resources.component';
export * from './resources/all-documents/all-documents.component';
export * from './resources/my-documents/my-documents.component';
export * from './resources/upload-document/upload-document.component';
export * from './resources/document/document.component';
export * from './resources/existing-documents/existing-documents.component';
export * from './resources/document-detail/document-detail.component';
export * from './resources/move-files-dialogue/move-files.component';
export * from './resources/shared-documents/shared-documents.component';
export * from './resources/approvals/approvals.component';
export * from './resources/share-document/share-document.component';
export * from './user-groups/user-grp-list/user-groups.component';
export * from './user-groups/add-group/add-group.component';
export * from './user-groups/group-detail/group-detail.component';
export * from './user-messages/inbox/inbox.component';
export * from './user-messages/compose-message/compose-message.component';
export * from './profile/edit-profile/profile-edit.component';
export * from './tags/listing-tags/listing-tags.component';
export * from './profile/change-password/change-password.component';
export * from './capabilities/list-capabilities/list-capabilities.component';
export * from './templates/templateManagementRouteComponent';
export * from './templates/template-listing/templates-list.component'
export * from './templates/edit-template/edit-template.component'
export * from './resources/doc-list-view/doc-list-view.component'
export * from './resources/tags-approval-list/tags-approval-list.component'
export * from './capabilities/add-role/add-role.component';
export * from './capabilities/edit-role/edit-role.component';
export * from './configurations/list-configurations/list-configurations.component';
export * from './notifications/manage-notifications/manage-notifications.component';
export * from './templates/replacement-patterns/modify-replacement-pattern/modify-replacement-pattern.component';
export * from './resources/access-request-list/request-access-list.component'
export * from './notifications/web-notifications/list/list.component';
export * from './capabilities/view-logs/view-logs.component';


